import { HTTP_METHODS } from '@studio/constants/axios';
import { CENTRAL_API_V3 } from '@studio/constants/env-variables';
import type API from '@resi-media/api-types';

export const root = {
  [HTTP_METHODS.POST]: {
    method: HTTP_METHODS.POST,
    request: {} as API.Central.V3.Schedules.Post.ExDate.Request,
    query: {} as {
      exDate: string;
    },
    url: `${CENTRAL_API_V3}/customers/@customerId/schedules/@contentScheduleId/exdate`,
  },
};
